/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdDomainSettingsUnityOptionsDistributionWebGlContextOpts, FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptsFromJSONTyped, FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptsToJSON, } from './FxIdDomainSettingsUnityOptionsDistributionWebGlContextOpts';
export function FxIdDomainSettingsUnityOptionsDistributionOptionsWebGlContextOptsFromJSON(json) {
    return FxIdDomainSettingsUnityOptionsDistributionOptionsWebGlContextOptsFromJSONTyped(json, false);
}
export function FxIdDomainSettingsUnityOptionsDistributionOptionsWebGlContextOptsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsUnityOptionsDistributionWebGlContextOpts(json)) {
        return FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdDomainSettingsUnityOptionsDistributionOptionsWebGlContextOptsToJSON(json) {
    return FxIdDomainSettingsUnityOptionsDistributionOptionsWebGlContextOptsToJSONTyped(json, false);
}
export function FxIdDomainSettingsUnityOptionsDistributionOptionsWebGlContextOptsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdDomainSettingsUnityOptionsDistributionWebGlContextOpts(value)) {
        return FxIdDomainSettingsUnityOptionsDistributionWebGlContextOptsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdDomainSettingsUnityOptionsDistributionOptionsWebGlContextOpts.js.map